import { Language } from "@/i18n/translations";
import { RouteMapping } from "./route-mapping";

/**
 * Extended route mappings for all pages in the site
 * Includes areas, blog posts, and all service sub-pages
 */

// Area pages (Houston neighborhoods)
export const areaRoutes: Record<string, RouteMapping> = {
  theWoodlands: {
    en: "/areas/the-woodlands",
    es: "/es/areas/the-woodlands",
    vi: "/vi/khu-vuc/the-woodlands"
  },
  katy: {
    en: "/areas/katy",
    es: "/es/areas/katy",
    vi: "/vi/khu-vuc/katy"
  },
  heights: {
    en: "/areas/heights",
    es: "/es/areas/heights",
    vi: "/vi/khu-vuc/heights"
  },
  midtown: {
    en: "/areas/midtown",
    es: "/es/areas/midtown",
    vi: "/vi/khu-vuc/midtown"
  },
  montrose: {
    en: "/areas/montrose",
    es: "/es/areas/montrose",
    vi: "/vi/khu-vuc/montrose"
  },
  cypress: {
    en: "/areas/cypress",
    es: "/es/areas/cypress",
    vi: "/vi/khu-vuc/cypress"
  },
  downtown: {
    en: "/areas/downtown",
    es: "/es/areas/downtown",
    vi: "/vi/khu-vuc/downtown"
  },
  energyCorridor: {
    en: "/areas/energy-corridor",
    es: "/es/areas/energy-corridor",
    vi: "/vi/khu-vuc/energy-corridor"
  },
  greaterSouthwest: {
    en: "/areas/greater-southwest",
    es: "/es/areas/greater-southwest",
    vi: "/vi/khu-vuc/greater-southwest"
  },
  medicalCenter: {
    en: "/areas/medical-center",
    es: "/es/areas/medical-center",
    vi: "/vi/khu-vuc/medical-center"
  },
  memorial: {
    en: "/areas/memorial",
    es: "/es/areas/memorial",
    vi: "/vi/khu-vuc/memorial"
  },
  riverOaks: {
    en: "/areas/river-oaks",
    es: "/es/areas/river-oaks",
    vi: "/vi/khu-vuc/river-oaks"
  },
  springBranch: {
    en: "/areas/spring-branch",
    es: "/es/areas/spring-branch",
    vi: "/vi/khu-vuc/spring-branch"
  },
  sugarLand: {
    en: "/areas/sugar-land",
    es: "/es/areas/sugar-land",
    vi: "/vi/khu-vuc/sugar-land"
  },
  uptown: {
    en: "/areas/uptown",
    es: "/es/areas/uptown",
    vi: "/vi/khu-vuc/uptown"
  },
  westUniversity: {
    en: "/areas/west-university",
    es: "/es/areas/west-university",
    vi: "/vi/khu-vuc/west-university"
  }
};

// Blog posts
export const blogRoutes: Record<string, RouteMapping> = {
  asylumProcess: {
    en: "/blog/understanding-asylum-process-2025",
    es: "/es/blog/entendiendo-proceso-asilo-2025",
    vi: "/vi/blog/hieu-quy-trinh-ti-nan-2025"
  },
  deportationDefense: {
    en: "/blog/what-to-do-facing-deportation",
    es: "/es/blog/que-hacer-enfrentando-deportacion",
    vi: "/vi/blog/phai-lam-gi-khi-doi-mat-truy-xuat"
  },
  citizenshipGuide: {
    en: "/blog/citizenship-naturalization-guide",
    es: "/es/blog/guia-ciudadania-naturalizacion",
    vi: "/vi/blog/huong-dan-quoc-tich-nhap-tich"
  },
  policeRights: {
    en: "/blog/rights-during-police-stop",
    es: "/es/blog/derechos-durante-control-policial",
    vi: "/vi/blog/quyen-khi-canh-sat-dung-xe"
  },
  personalInjuryClaim: {
    en: "/blog/handle-personal-injury-claim",
    es: "/es/blog/manejar-reclamo-lesiones-personales",
    vi: "/vi/blog/xu-ly-khieu-nai-thuong-tich"
  },
  divorceTexas: {
    en: "/blog/divorce-texas-guide",
    es: "/es/blog/guia-divorcio-texas",
    vi: "/vi/blog/huong-dan-ly-hon-texas"
  }
};

// Criminal Defense sub-pages
export const criminalDefenseRoutes: Record<string, RouteMapping> = {
  dwi: {
    en: "/practice-areas/criminal-defense/dwi",
    es: "/es/areas-de-practica/defensa-criminal/dwi",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/dwi"
  },
  drugCharges: {
    en: "/practice-areas/criminal-defense/drug-charges",
    es: "/es/areas-de-practica/defensa-criminal/cargos-drogas",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/cao-buoc-ma-tuy"
  },
  assault: {
    en: "/practice-areas/criminal-defense/assault-family-violence",
    es: "/es/areas-de-practica/defensa-criminal/asalto-violencia-familiar",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/hanh-hung-bao-luc-gia-dinh"
  },
  violentCrimes: {
    en: "/practice-areas/criminal-defense/violent-crimes",
    es: "/es/areas-de-practica/defensa-criminal/crimenes-violentos",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/toi-bao-luc"
  },
  sexCrimes: {
    en: "/practice-areas/criminal-defense/sex-crimes",
    es: "/es/areas-de-practica/defensa-criminal/delitos-sexuales",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/toi-tinh-duc"
  },
  theftRobbery: {
    en: "/practice-areas/criminal-defense/theft-robbery",
    es: "/es/areas-de-practica/defensa-criminal/robo-hurto",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/trom-cap-cuop"
  },
  expunction: {
    en: "/practice-areas/criminal-defense/expunction-nondisclosure",
    es: "/es/areas-de-practica/defensa-criminal/expuncion-no-divulgacion",
    vi: "/vi/linh-vuc-hanh-nghe/bao-ve-hinh-su/xoa-an-khong-tiet-lo"
  }
};

// Family Law sub-pages
export const familyLawRoutes: Record<string, RouteMapping> = {
  divorce: {
    en: "/practice-areas/family-law/divorce",
    es: "/es/areas-de-practica/derecho-familiar/divorcio",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/ly-hon"
  },
  childCustody: {
    en: "/practice-areas/family-law/child-custody",
    es: "/es/areas-de-practica/derecho-familiar/custodia-menores",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/quyen-nuoi-con"
  },
  childSupport: {
    en: "/practice-areas/family-law/child-support",
    es: "/es/areas-de-practica/derecho-familiar/manutencion-menores",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/ho-tro-tre-em"
  },
  cpsDefense: {
    en: "/practice-areas/family-law/cps-defense",
    es: "/es/areas-de-practica/derecho-familiar/defensa-cps",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/bao-ve-cps"
  },
  adoption: {
    en: "/practice-areas/family-law/adoption",
    es: "/es/areas-de-practica/derecho-familiar/adopcion",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/nhan-nuoi"
  },
  courtOrderModification: {
    en: "/practice-areas/family-law/court-order-modification",
    es: "/es/areas-de-practica/derecho-familiar/modificacion-orden-judicial",
    vi: "/vi/linh-vuc-hanh-nghe/luat-gia-dinh/sua-doi-lenh-toa"
  }
};

// Personal Injury sub-pages
export const personalInjuryRoutes: Record<string, RouteMapping> = {
  autoAccident: {
    en: "/practice-areas/personal-injury/auto-accident",
    es: "/es/areas-de-practica/lesiones-personales/accidente-auto",
    vi: "/vi/linh-vuc-hanh-nghe/thuong-tich-ca-nhan/tai-nan-o-to"
  },
  truckAccident: {
    en: "/practice-areas/personal-injury/truck-accident",
    es: "/es/areas-de-practica/lesiones-personales/accidente-camion",
    vi: "/vi/linh-vuc-hanh-nghe/thuong-tich-ca-nhan/tai-nan-xe-tai"
  },
  medicalMalpractice: {
    en: "/practice-areas/personal-injury/medical-malpractice",
    es: "/es/areas-de-practica/lesiones-personales/negligencia-medica",
    vi: "/vi/linh-vuc-hanh-nghe/thuong-tich-ca-nhan/sai-sot-y-khoa"
  },
  industrialAccident: {
    en: "/practice-areas/personal-injury/industrial-accident",
    es: "/es/areas-de-practica/lesiones-personales/accidente-industrial",
    vi: "/vi/linh-vuc-hanh-nghe/thuong-tich-ca-nhan/tai-nan-cong-nghiep"
  }
};

// Real Estate sub-pages
export const realEstateRoutes: Record<string, RouteMapping> = {
  closings: {
    en: "/practice-areas/real-estate-law/closings",
    es: "/es/areas-de-practica/derecho-inmobiliario/cierres",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/dong-giao-dich"
  },
  buyingSelling: {
    en: "/practice-areas/real-estate-law/buying-selling",
    es: "/es/areas-de-practica/derecho-inmobiliario/compra-venta",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/mua-ban"
  },
  foreclosuresEvictions: {
    en: "/practice-areas/real-estate-law/foreclosures-evictions",
    es: "/es/areas-de-practica/derecho-inmobiliario/ejecuciones-desalojos",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/tich-thu-truc-xuat"
  },
  titleServices: {
    en: "/practice-areas/real-estate-law/title-services",
    es: "/es/areas-de-practica/derecho-inmobiliario/servicios-titulo",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/dich-vu-chung-thu"
  },
  transactions: {
    en: "/practice-areas/real-estate-law/transactions",
    es: "/es/areas-de-practica/derecho-inmobiliario/transacciones",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/giao-dich"
  },
  landlordTenant: {
    en: "/practice-areas/real-estate-law/landlord-tenant",
    es: "/es/areas-de-practica/derecho-inmobiliario/arrendador-inquilino",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/chu-nha-nguoi-thue"
  },
  contractReview: {
    en: "/practice-areas/real-estate-law/contract-review",
    es: "/es/areas-de-practica/derecho-inmobiliario/revision-contratos",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/xem-xet-hop-dong"
  },
  titleSearch: {
    en: "/practice-areas/real-estate-law/title-search",
    es: "/es/areas-de-practica/derecho-inmobiliario/busqueda-titulo",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/tim-kiem-chung-thu"
  },
  leaseNegotiations: {
    en: "/practice-areas/real-estate-law/lease-negotiations",
    es: "/es/areas-de-practica/derecho-inmobiliario/negociacion-arrendamiento",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/dam-phan-thue"
  },
  foreclosureDisputes: {
    en: "/practice-areas/real-estate-law/foreclosure-disputes",
    es: "/es/areas-de-practica/derecho-inmobiliario/disputas-ejecucion",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/tranh-chap-tich-thu"
  },
  affidavitsHeirship: {
    en: "/practice-areas/real-estate-law/affidavits-heirship",
    es: "/es/areas-de-practica/derecho-inmobiliario/declaraciones-herederos",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/tuyen-bo-ke-thua"
  },
  lienRelease: {
    en: "/practice-areas/real-estate-law/lien-release",
    es: "/es/areas-de-practica/derecho-inmobiliario/liberacion-gravamen",
    vi: "/vi/linh-vuc-hanh-nghe/luat-bat-dong-san/giai-phong-quyen-tru-lieu"
  }
};

// Business Law sub-pages
export const businessLawRoutes: Record<string, RouteMapping> = {
  businessFormation: {
    en: "/practice-areas/business-law/business-formation",
    es: "/es/areas-de-practica/derecho-empresarial/formacion-negocios",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/thanh-lap-doanh-nghiep"
  },
  contractsAgreements: {
    en: "/practice-areas/business-law/contracts-agreements",
    es: "/es/areas-de-practica/derecho-empresarial/contratos-acuerdos",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/hop-dong-thoa-thuan"
  },
  purchaseSaleBusiness: {
    en: "/practice-areas/business-law/purchase-sale-business",
    es: "/es/areas-de-practica/derecho-empresarial/compra-venta-negocios",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/mua-ban-doanh-nghiep"
  },
  debtCollection: {
    en: "/practice-areas/business-law/debt-collection",
    es: "/es/areas-de-practica/derecho-empresarial/cobro-deudas",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/thu-hoi-no"
  },
  businessTransactions: {
    en: "/practice-areas/business-law/business-transactions",
    es: "/es/areas-de-practica/derecho-empresarial/transacciones-comerciales",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/giao-dich-thuong-mai"
  },
  intellectualProperty: {
    en: "/practice-areas/business-law/intellectual-property",
    es: "/es/areas-de-practica/derecho-empresarial/propiedad-intelectual",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/so-huu-tri-tue"
  },
  partnershipAgreements: {
    en: "/practice-areas/business-law/partnership-agreements",
    es: "/es/areas-de-practica/derecho-empresarial/acuerdos-socios",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/thoa-thuan-hop-tac"
  },
  trademarkRegistration: {
    en: "/practice-areas/business-law/trademark-registration",
    es: "/es/areas-de-practica/derecho-empresarial/registro-marcas",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/dang-ky-thuong-hieu"
  },
  nonprofitFormation: {
    en: "/practice-areas/business-law/nonprofit-formation",
    es: "/es/areas-de-practica/derecho-empresarial/formacion-sin-fines-lucro",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/thanh-lap-phi-loi-nhuan"
  },
  registeredAgent: {
    en: "/practice-areas/business-law/registered-agent",
    es: "/es/areas-de-practica/derecho-empresarial/agente-registrado",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/dai-dien-dang-ky"
  },
  insuranceClaims: {
    en: "/practice-areas/business-law/insurance-claims",
    es: "/es/areas-de-practica/derecho-empresarial/reclamos-seguros",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/khieu-nai-bao-hiem"
  },
  businessClosing: {
    en: "/practice-areas/business-law/business-closing",
    es: "/es/areas-de-practica/derecho-empresarial/cierre-negocios",
    vi: "/vi/linh-vuc-hanh-nghe/luat-doanh-nghiep/dong-cua-doanh-nghiep"
  }
};

// Probate & Estate sub-pages
export const probateEstateRoutes: Record<string, RouteMapping> = {
  estatePlanning: {
    en: "/practice-areas/probate-estate/estate-planning",
    es: "/es/areas-de-practica/sucesiones-testamentos/planificacion-patrimonial",
    vi: "/vi/linh-vuc-hanh-nghe/di-san-va-di-chuc/lap-ke-hoach-di-san"
  },
  probateAdministration: {
    en: "/practice-areas/probate-estate/probate-administration",
    es: "/es/areas-de-practica/sucesiones-testamentos/administracion-sucesiones",
    vi: "/vi/linh-vuc-hanh-nghe/di-san-va-di-chuc/quan-ly-di-chuc"
  },
  guardianship: {
    en: "/practice-areas/probate-estate/guardianship",
    es: "/es/areas-de-practica/sucesiones-testamentos/tutela",
    vi: "/vi/linh-vuc-hanh-nghe/di-san-va-di-chuc/giam-ho"
  },
  specialNeedsTrust: {
    en: "/practice-areas/probate-estate/special-needs-trust",
    es: "/es/areas-de-practica/sucesiones-testamentos/fideicomiso-necesidades-especiales",
    vi: "/vi/linh-vuc-hanh-nghe/di-san-va-di-chuc/uy-thac-nhu-cau-dac-biet"
  }
};

// Tax Law sub-pages
export const taxLawRoutes: Record<string, RouteMapping> = {
  taxPlanning: {
    en: "/practice-areas/tax-law/tax-planning",
    es: "/es/areas-de-practica/derecho-fiscal/planificacion-fiscal",
    vi: "/vi/linh-vuc-hanh-nghe/luat-thue/lap-ke-hoach-thue"
  },
  taxDebtResolution: {
    en: "/practice-areas/tax-law/tax-debt-resolution",
    es: "/es/areas-de-practica/derecho-fiscal/resolucion-deuda-fiscal",
    vi: "/vi/linh-vuc-hanh-nghe/luat-thue/giai-quyet-no-thue"
  },
  taxLitigation: {
    en: "/practice-areas/tax-law/tax-litigation",
    es: "/es/areas-de-practica/derecho-fiscal/litigio-fiscal",
    vi: "/vi/linh-vuc-hanh-nghe/luat-thue/kien-tung-thue"
  }
};

// Other pages
export const otherRoutes: Record<string, RouteMapping> = {
  tools: {
    en: "/tools",
    es: "/es/herramientas",
    vi: "/vi/cong-cu"
  },
  privacyPolicy: {
    en: "/privacy-policy",
    es: "/es/politica-privacidad",
    vi: "/vi/chinh-sach-rieng-tu"
  },
  termsOfUse: {
    en: "/terms-of-use",
    es: "/es/terminos-uso",
    vi: "/vi/dieu-khoan-su-dung"
  }
};

// Combine all extended routes
export const allExtendedRoutes = {
  ...areaRoutes,
  ...blogRoutes,
  ...criminalDefenseRoutes,
  ...familyLawRoutes,
  ...personalInjuryRoutes,
  ...realEstateRoutes,
  ...businessLawRoutes,
  ...probateEstateRoutes,
  ...taxLawRoutes,
  ...otherRoutes
};
